import type {Locale} from '.';

const localeValues: Locale = {
    locale: 'zh-cn',
    EmptyStatus: {
        noResult: '暂无结果',
        noAccessPermissions: '没有访问权限',
        connectAdministrator: '如果您需要此页面的访问权限，请联系管理员配置',
        replaceKeywords: '请尝试更换关键词',
        pageNotFound: '无法找到页面',
        pageDoesNotExist: '您访问的页面不存在，',
        refreshPage: '刷新页面',
        serverError: '服务器错误',
        serverErrorNoResponse: '服务器错误无法响应，',
        returnHome: '返回首页，',
        problemStillExists: '如果问题依然存在，请联系管理员',
        please: '请',
        againLater: '请稍后重试',
        or: '或'
    },
    Status: {
        running: '运行中',
        warning: '警告',
        success: '运行成功',
        error: '运行错误',
        unavailable: '不可用'
    },
    FileUpload: {
        uploadFailed: '上传失败',
        updateCompleted: '更新成功',
        noticeCopywriting: '注意：请调整文件名后再上传，以便其他人可以识别'
    },
    Loading: {
        Loading: '玩命加载中...'
    },
    useList: {
        loadingData: '数据加载中...',
        noData: '暂无数据',
        total: '共',
        stripData: '条数据'
    },
    useTable: {
        confirm: '确认',
        requestFailedPleaseCheck: '请求失败，请检查',
        total: '共',
        stripData: '条数据',
        failedToGetRecords: '获取记录失败'
    },
    HooksList: {
        chosen: '已选择',
        Record: '条记录',
        startingTime: '开始时间',
        endTime: '结束时间',
        startDate: '开始日期',
        endData: '结束日期'
    },
    HooksTable: {
        sure: '确定',
        cancel: '取消',
        submitting: '提交中...',
        noResult: '暂无结果',
        noData: '暂无数据',
        no: '您还没有',
        any: '任何',
        create: '创建',
        new: '新建'
    },
    useDialog: {
        sure: '确定',
        cancel: '取消',
        submitting: '提交中...'
    }
};

export default localeValues;